var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22998 7.38802C8.22998 5.13286 10.0582 3.30469 12.3133 3.30469H44.98C47.2352 3.30469 49.0633 5.13287 49.0633 7.38802V49.388C49.0633 51.6432 47.2352 53.4714 44.98 53.4714H12.3133C10.0582 53.4714 8.22998 51.6432 8.22998 49.388V7.38802ZM12.3133 6.80469C11.9911 6.80469 11.73 7.06585 11.73 7.38802V49.388C11.73 49.7102 11.9911 49.9714 12.3133 49.9714H44.98C45.3022 49.9714 45.5633 49.7102 45.5633 49.388V7.38802C45.5633 7.06584 45.3022 6.80469 44.98 6.80469H12.3133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.73 35.388C18.73 34.4215 19.5135 33.638 20.48 33.638H36.8133C37.7798 33.638 38.5633 34.4215 38.5633 35.388C38.5633 36.3545 37.7798 37.138 36.8133 37.138H20.48C19.5135 37.138 18.73 36.3545 18.73 35.388Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.73 42.388C18.73 41.4215 19.5135 40.638 20.48 40.638H28.6466C29.6131 40.638 30.3966 41.4215 30.3966 42.388C30.3966 43.3545 29.6131 44.138 28.6466 44.138H20.48C19.5135 44.138 18.73 43.3545 18.73 42.388Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8841 14.3173C37.5675 15.0007 37.5675 16.1087 36.8841 16.7921L27.5508 26.1255C26.8673 26.8089 25.7593 26.8089 25.0759 26.1255L20.4092 21.4588C19.7258 20.7754 19.7258 19.6673 20.4092 18.9839C21.0926 18.3005 22.2007 18.3005 22.8841 18.9839L26.3133 22.4131L34.4092 14.3173C35.0926 13.6338 36.2007 13.6338 36.8841 14.3173Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocSuccess);
export default __webpack_public_path__ + "static/media/doc-success.10e694fc.svg";
export { ForwardRef as ReactComponent };